import React from 'react';
import { NEWS_ITEMS } from '../mock';
import { Calendar, ArrowRight, BookOpen } from 'lucide-react';

const NewsPage = () => {
  const featured = NEWS_ITEMS.find((n) => n.featured);
  const others = NEWS_ITEMS.filter((n) => !n.featured);

  return (
    <div className="pt-28 pb-20 bg-[#0a0608] min-h-screen">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
        <div className="mb-12 text-center fade-up">
          <p className="font-nav text-[#f5b400] text-xs tracking-widest">UPDATES</p>
          <h1 className="font-heading section-heading-white mt-3">LATEST</h1>
          <h1 className="font-heading section-heading-gold">NEWS &amp; UPDATES</h1>
          <div className="mx-auto mt-6 h-1 w-24 bg-[#f5b400]" />
        </div>

        {featured && (
          <article
            id={`post-${featured.id}`}
            className="mb-12 rounded-2xl border border-[#f5b400]/40 bg-gradient-to-br from-black/70 via-[#1a1410]/60 to-black/70 p-7 md:p-10 fade-up shadow-[0_0_40px_-15px_rgba(245,180,0,0.4)]"
          >
            <div className="flex items-center gap-3 mb-3">
              <span className="font-nav text-[10px] tracking-widest text-black bg-[#f5b400] px-3 py-1 rounded-full inline-flex items-center gap-1">
                <BookOpen size={11} /> FEATURED
              </span>
              <span className="inline-flex items-center gap-1 text-white/60 font-body text-xs">
                <Calendar size={13} className="text-[#f5b400]" />
                {featured.date}
              </span>
            </div>
            <h2 className="font-heading text-white text-3xl md:text-4xl leading-tight">
              {featured.title}
            </h2>
            <p className="font-body text-white/75 text-base mt-4 italic">{featured.excerpt}</p>

            <div className="mt-8 space-y-6">
              {(featured.body || []).map((section, i) => (
                <section key={i}>
                  <h3 className="font-heading text-[#f5b400] text-lg uppercase tracking-wide">
                    {section.heading}
                  </h3>
                  <p className="font-body text-white/85 text-sm md:text-base leading-relaxed mt-2">
                    {section.text}
                  </p>
                </section>
              ))}
            </div>

            <div className="mt-10 pt-6 border-t border-white/10 flex items-center justify-between">
              <span className="font-nav text-[10px] tracking-widest text-white/50">
                — THE NEW REALM ONLINE TEAM
              </span>
              <a
                href="#post-1"
                className="font-nav text-[10px] tracking-widest text-[#f5b400] hover:text-white transition-colors inline-flex items-center gap-1"
              >
                MORE UPDATES <ArrowRight size={12} />
              </a>
            </div>
          </article>
        )}

        <div className="grid grid-cols-1 gap-6">
          {others.map((n) => (
            <article
              key={n.id}
              id={`post-${n.id}`}
              className="rounded-xl border border-white/10 bg-black/40 p-7 hover:border-[#f5b400]/60 transition-colors group"
              data-testid={`news-post-${n.id}`}
            >
              <div className="flex items-center gap-2 text-white/60 font-body text-xs">
                <Calendar size={14} className="text-[#f5b400]" />
                {n.date}
              </div>
              <h2 className="font-heading text-white text-2xl md:text-3xl mt-3 leading-tight group-hover:text-[#f5b400] transition-colors">
                {n.title}
              </h2>
              <p className="font-body text-sm md:text-base text-white/75 mt-3 italic">{n.excerpt}</p>

              {n.body && n.body.length > 0 && (
                <details className="mt-5 group/details" data-testid={`news-post-${n.id}-details`}>
                  <summary className="cursor-pointer list-none inline-flex items-center gap-2 font-nav text-xs text-[#f5b400] hover:text-white transition-colors select-none">
                    <span className="group-open/details:hidden">READ FULL ARTICLE</span>
                    <span className="hidden group-open/details:inline">HIDE ARTICLE</span>
                    <ArrowRight
                      size={14}
                      className="transition-transform group-open/details:rotate-90"
                    />
                  </summary>
                  <div className="mt-6 space-y-6">
                    {n.body.map((section, i) => (
                      <section key={i}>
                        <h3 className="font-heading text-[#f5b400] text-base md:text-lg uppercase tracking-wide">
                          {section.heading}
                        </h3>
                        <p className="font-body text-white/85 text-sm md:text-base leading-relaxed mt-2">
                          {section.text}
                        </p>
                      </section>
                    ))}
                  </div>
                </details>
              )}

              {n.keywords && n.keywords.length > 0 && (
                <div
                  className="mt-6 pt-5 border-t border-white/10 flex flex-wrap gap-2"
                  aria-label="Related topics"
                  data-testid={`news-post-${n.id}-tags`}
                >
                  {n.keywords.map((kw, i) => (
                    <span
                      key={i}
                      className="font-nav text-[10px] tracking-widest text-[#f5b400] bg-[#f5b400]/10 border border-[#f5b400]/30 rounded-full px-3 py-1"
                    >
                      {kw.toUpperCase()}
                    </span>
                  ))}
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewsPage;
